import { UserProfileDto, UserRole, ImportPaygapPersonnelDto } from "@green0meter/api-client";
import {
  UseMutateFunction,
  useMutation,
  useQueryClient,
} from "@tanstack/react-query";

import { DOMAIN_PAYGAP } from "../domain";
import { ACTION_GET_CURRENT_COMPANY_PERSONNEL } from "../GetCurrentCompanyPersonnel/useGetCurrentCompanyPersonnel";

import { paygapApi } from "@api/services";
import { roleGuard } from "@api";

export const ACTION_IMPORT_PERSONNEL = "IMPORT_PERSONNEL";

const allowedRoles = [UserRole.Owner, UserRole.Manager];

const importPersonnel = async (req: ImportPaygapPersonnelDto): Promise<object[]> => {
  const response = await paygapApi.paygapControllerImportPersonnel(req);

  return response.data;
};

export const useImportPersonnel = (
  user: UserProfileDto | null,
): {
  importPersonnel: UseMutateFunction<object[], Error, ImportPaygapPersonnelDto, unknown>;
  importPersonnelEnabled: boolean;
  isSuccessImportPersonnel: boolean;
  isPendingImportPersonnel: boolean;
  importPersonnelError: Error | null;
} => {
  const enabled = roleGuard(user, allowedRoles);
  const queryClient = useQueryClient();

  const { mutate, isSuccess, isPending, error } = useMutation<object[], Error, ImportPaygapPersonnelDto, unknown>({
    mutationKey: [DOMAIN_PAYGAP, ACTION_IMPORT_PERSONNEL],
    mutationFn: enabled ? importPersonnel : async (): Promise<object[]> => {
      throw new Error('Insufficient permissions to import personnel data. Required roles: Owner or Manager.');
    },
    onSuccess: () => {
      // Invalidate personnel data to refetch after import
      queryClient.invalidateQueries({
        queryKey: [DOMAIN_PAYGAP, ACTION_GET_CURRENT_COMPANY_PERSONNEL],
      });
    },
  });

  return {
    importPersonnel: mutate,
    importPersonnelEnabled: enabled,
    isSuccessImportPersonnel: isSuccess,
    isPendingImportPersonnel: isPending,
    importPersonnelError: error,
  };
};
